import { Placeholder } from '@goodrx/matisse';
import { useSynapse } from 'app/lib/synaptik';
import React, { FC } from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';
import { getQueryParams } from 'app/lib/utils';
import qs from 'qs';

type AuthenticatedRouteProps = RouteProps;

export const AuthenticatedRoute: FC<AuthenticatedRouteProps> = ({
  component: Component,
  ...routeProps
}: AuthenticatedRouteProps) => {
  const [
    reauthenticating,
    authenticated,
    intendedService,
    deleteIntendedService,
    deleteRequestedDrug,
    activeVisit,
  ] = useSynapse(({ user, services, visits }) => [
    user.state.reauthenticating,
    user.state.authenticated,
    services.getIntendedServiceSlug(),
    services.deleteIntendedService,
    services.deleteRequestedDrug,
    visits.state.visit,
  ]);

  return (
    <Route
      {...routeProps}
      render={(renderProps) => (
        <Placeholder loading={reauthenticating}>
          {() => {
            if (!authenticated) {
              const searchParams = getQueryParams();
              return (
                <Redirect
                  to={{
                    pathname: '/login',
                    search: qs.stringify({ ...searchParams, next: renderProps.location.pathname }),
                    state: { from: renderProps.location },
                  }}
                />
              );
            }

            if (intendedService) {
              deleteIntendedService();

              if (activeVisit) {
                deleteRequestedDrug();

                return (
                  <Redirect
                    to={{
                      pathname: `/visits/${activeVisit.id}/getting-started`,
                    }}
                  />
                );
              }

              return (
                <Redirect
                  to={{
                    pathname: `/start/${intendedService}`,
                  }}
                />
              );
            }

            if (Component) {
              return <Component {...renderProps} />;
            }

            return null;
          }}
        </Placeholder>
      )}
    />
  );
};
